// extracted by mini-css-extract-plugin
export default {"PartnerExpenseList":"ProjectPartnersExpensesList_PartnerExpenseList__C+ZNP"};